
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { 
  TestPaperLibraryOVO, 
  CorrectAnswerOVO, 
  UserAnswerMstIVO, 
  UserAnswerSlvIVO, 
  TestPaperIVO, 
  TestPaperOVO,
  MstKeypointVO } from '@/views/biz/omr/vo/Omr.vo'
import axios from 'axios'
import CommonUtils from '@/common-utils'
import SettingsDialog from '@/components/SettingsDialog.vue'
import ExplanationDialog from '@/components/ExplanationDialog.vue'
import ExplanationFormDialog from '@/components/ExplanationFormDialog.vue'
import WrongAnswerNoteDialog from '@/components/WrongAnswerNoteDialog.vue'
import HelpDialog from '@/components/HelpDialog.vue'
import reportDialog from '@/components/ReportDialog.vue'
import ReportHistoryComponent from '@/components/ReportHistoryComponent.vue'
import TestPaperDialog from '@/components/TestPaperDialog.vue'
import Constants from '@/constants'
import { SettingsOmrVO } from '@/components/vo/Settings.vo'
import { SnackbarHideVO } from '@/components/vo/Snackbar.vo'
import mobileDeviceDetect from 'mobile-device-detect'

@Component({
  components: {
      ExplanationDialog
    , ExplanationFormDialog
    , reportDialog
    , ReportHistoryComponent
    , HelpDialog
    , TestPaperDialog
  }
})
export default class OmrLearn extends Vue {
  @Prop() emNo!: string;
  model = false;
  dialogTab2 = null;
  drawNav = true;
  mini = true;
  windowSize = {
    x: 0,
    y: 0,
  }
  imgWidth = 800;
  questionStartNumber = 0;
  isFocusTestPaper = false;

  isLoadedTestImages = false;

  answerNumbering = {
    exam3 : [1, 16, 31], // 대체 시험 문제 시작 넘버링
    exam4 : [1, 36],     // 기말 시험 문제 시작 넘버링
    exam5 : [1],         // 하계 시험 문제 시작 넘버링
    exam6 : [1]          // 동계 시험 문제 시작 넘버링
  };

  // 중복 정답안
  dupleAnswer = {
    A : '12',
    B : '13',
    C : '14',
    D : '23',
    E : '24',
    F : '34',
    G : '123',
    H : '124',
    I : '134',
    J : '234',
    K : '1234'
  };

  // 기출문제 시험지 라이브러리에서 조회한 결과
  testPaperLibraries: Array<TestPaperLibraryOVO> = [] as Array<TestPaperLibraryOVO>;
  testPapers: Array<TestPaperOVO> = [] as Array<TestPaperOVO>
  currentExplanation = {} as CorrectAnswerOVO;

  userAnswerMstIVO: UserAnswerMstIVO = {} as UserAnswerMstIVO;
  // 정답안
  correctAnswers: Array<CorrectAnswerOVO> = [] as Array<CorrectAnswerOVO>;
  // 사용자 답안
  userAnswers: Array<UserAnswerSlvIVO> = [] as Array<UserAnswerSlvIVO>;
  // 환경설정
  settings: SettingsOmrVO = {} as SettingsOmrVO;
  // 스낵바 도움말 다시보지 않기 설정값
  snackbarHide: SnackbarHideVO = {} as SnackbarHideVO;


  isOpenedSnackbar = false;
  endedTest = false;

  // 기출문제 자료 개수
  testPaperCount = 0;


  // 도움말
  msgDialog = false;
  currentHelpMsg = {};
  gradeHelpMsg = {
    title: '채점모드 도움말',
    msg: '각 문항을 선택할 때마다 자동으로 채점을 해주는 기능이예요. 설정된 문항수에 따라 채점이 자동으로 진행돼요.',
  };

  correctAnswerPstgMsg = {
    title: '정답률 도움말',
    msg: '모든 수험생들이 제출한 데이터의 정답률을 계산하여 각 문항에 표시를 해줘요. 낮게 설정할수록 고난이도의 문제들만 노출돼요.',
  }

  hideGradeSuccessMsg = {
    title: '문항 가리기 도움말',
    msg: '채점이 완료된 문제는 답안지에서 가려요. 채점이 완료된 문항이 계속 보일 필요는 없겠죠?',
  }

  isGroupQuestionMsg = {
    title: '오답노트 문항노출 도움말',
    msg: '내가 푼 문제의 정답률이 오답노트에 노출될지 여부를 결정해요. 보고싶은 구간만 선택하면 보기 더 편해요.'
  }

  hideModeMsg = {
    title: '가리기 모드 도움말',
    msg: '비노출 문항을 완전히 가리거나 또는 흐리게 노출되도록 설정해요.'
  }

  autoSwapMsg = {
    title: '답 선택 시 자료 스왑',
    msg: '답안지의 답항을 선택하면 기출문제 자료가 자동으로 열려요. 답을 선택 후 자연스럽게 다음 문제를 확인하기 용이해요.',
  }

  // 타이머 사용
  isUseTimer = false;
  timer;
  restTime = 0;

  // 제출
  isReport = false;

  // 카드 사이즈
  get windowResizer1() {
    return `${this.windowSize.y - 64 - 24 - 24 - 160}px`;
  } 

  // 모든 문제를 선택 & 자동 채점 모드가 off
  get isGradingSnackbar() {
    return this.mini == true && this.isOpenedSnackbar == false && this.settings.isAutoGrade == false && this.isAllMaiking
  }

  // 모름을 선택한 문항
  get unknownAnswers() {
    return this.userAnswers.filter(v => v.uaSvAnsr && v.uaSvAnsr == '0');
  }

  // 모름이 제외된 체크된 답항
  get getSelectedAnswersByExcludeUnknown() {
    return this.userAnswers.filter(v => v.uaSvAnsr);
  }

  // 답안을 체크한 문항
  get getSelectedAnswers() {
    return this.userAnswers.filter(v => v.uaSvAnsr == '0' || v.uaSvAnsr);
  }

  // 채점이 완료된 문항
  get getGradingQuestions() {
    return this.getSelectedAnswers.filter(v => v.isGrading == true)
  }

  // 모든 답안을 체크했는지 여부
  get isAllMaiking() {
    return this.getSelectedAnswers.length == this.correctAnswers.length;
  }

  // 진척률
  get progressRate() {
    return (this.getSelectedAnswers.length / this.correctAnswers.length)*100
  }

  get convertSecondToMinute() {
    if(!this.restTime) {
      return `${this.settings.timerMinute}:00`
    }

    const min = Math.floor((this.restTime%3600)/60);
    const sec = this.restTime%60;
    return `${min < 10 ? '0'+ min: min}:${sec < 10 ? '0'+ sec: sec}`;
  }

  get isMobileReally() {
    const userAgent = navigator.userAgent.toLowerCase();
    return mobileDeviceDetect.isMobile || userAgent.indexOf('knou-omr-app') > -1;
  }


  openHelpMessages(msg): void {
    this.msgDialog = !this.msgDialog;
    this.currentHelpMsg = msg;
  }

  // dragscroll 때문에 부득이하게 추가됨
  // height가 지정되지 않으면 dragscroll동작 오류
  onResize(): void {
    this.windowSize = { x: window.innerWidth, y: window.innerHeight };
  }

  // 답안 체크
  selectAnswer(answer, qNo): void {
    if ( this.userAnswers[qNo].isGrading == true ) {
      this.$toast('채점이 완료되면 수정이 안돼요');
      return;
    }

    if(this.settings.isAutoSwap == true) {
      this.$store.dispatch('testPaper/openModal', {name: 'testPaper'});
    }

    // 같은 답 선택 시 취소
    const tmpAnswer: UserAnswerSlvIVO = {} as UserAnswerSlvIVO;
    if ( this.userAnswers[qNo].uaSvAnsr != answer ) {
      tmpAnswer.uaSvAnsr = answer;
    }
    this.$set(this.userAnswers, qNo, tmpAnswer);

    // 자동채점 모드가 아니면
    if(this.settings.isAutoGrade == false) {
      return;
    }

    // 자동채점 개수만큼 채워지지 않았다면
    if(this.getSelectedAnswers.length && this.getSelectedAnswers.length % this.settings.gradeQstCnt != 0) {
      return;
    }

    this.grading();
  }

  // 채점
  grading() {
    this.userAnswers.forEach((item: UserAnswerSlvIVO, i: number) => {
      if(item.uaSvAnsr != '0' && !item.uaSvAnsr) {
        return;
      }

      const correctAnswer = this.correctAnswers[i];
      let status = '2';         // 기본값 모름으로 설정

      // 중복 정답이면
      if(correctAnswer.dupleAnsr != '0') {
        status = this.dupleAnswer[correctAnswer.caAnsr].indexOf(item.uaSvAnsr) >= 0 ? '1' : '0';
      } 
      // 그 외
      else {
        if(item.uaSvAnsr) {
          status = correctAnswer.caAnsr == item.uaSvAnsr ? '1': '0';
        }
      }

      // 사용자 답안객체에 값 저장
      this.$set(item, 'uaStatus', status);
      this.$set(item, 'isGrading', status != '2' ? true: false);
      this.$set(item, 'caNo', correctAnswer.caNo);
    })

    this.reporting();
  }

  // 결과
  reporting() {
    if(this.isAllMaiking == false) {
      return;
    }
    
    this.$store.dispatch(`report/openModal`, {name: 'report'});
  }

  // 답안 선택 시 css 처리
  getClassUserAnswer(index, answer) {
    // 모름 선택 시
    if(!answer) {
      return `unknown${index+1}${answer}` == `unknown${index+1}${this.userAnswers[index].uaSvAnsr}` ? `unknown${index+1}${answer}`: '';
    } else {
      return `ua${index+1}${answer}` == `ua${index+1}${this.userAnswers[index].uaSvAnsr}` ? `ua${index+1}${answer}`: '';
    }
  }

  // 채점 답안 css 처리
  getGradingAnswer(index, qNo, correctAnswer, answer) {
    if(!this.userAnswers[index].isGrading) return;

    let prefixClass = '';

    switch(this.userAnswers[index].uaStatus) {
      case '0': 
        prefixClass = 'ca';
        break;
      case '1':
        prefixClass = 'correct';
        break;
      case '2':
        prefixClass = 'correct';
        break;
      default:
        break;
    }

    if(correctAnswer.dupleAnsr == 1) {
      const cAnswer = correctAnswer.caAnsr;

      if(this.dupleAnswer[cAnswer].indexOf(answer) != -1) {
        return `${prefixClass}${qNo}${answer}`
      }
    }

    return `${prefixClass}${qNo}${answer}` == `${prefixClass}${qNo}${correctAnswer.caAnsr}` ? `${prefixClass}${qNo}${answer}`: ''
  }

  // 문항 수 변경
  refreshAnswerNumbering() {
    this.questionStartNumber = (this.questionStartNumber + 1) % (this.answerNumbering['exam' + this.correctAnswers[0].emExam].length);
  }

  // 풀이/메모 조회
  viewExplanation(item: CorrectAnswerOVO): void {
    this.currentExplanation = item;
    this.$store.dispatch(`explanation/openModal`, {name: 'explanation'});
  }

  // 핵심포인트 문제 등록/삭제
  setKeypoint(qstNo: number) {
    const param: MstKeypointVO = {} as MstKeypointVO;
    param.emNo = this.emNo;
    param.qstNo = qstNo;

    axios.post('/omr/keypoint', param)
    .then(r=>{
      this.correctAnswers[qstNo-1].keypoint = r.data;
      if(r.data) {
        this.$toast('핵심 문제로 등록됐어요');
        return;
      }
      this.$toast('해제 됐어요');
    })
  }

  getWindowSize(){
    switch (this.$vuetify.breakpoint.name) {
      case 'xs': return 220
      case 'sm': return 400
      case 'md': return 500
      case 'lg': return 600
      case 'xl': return 800
    }
  }

  // 환경설정에 [채점이 완료된 문제 가리기]가 체크되면..
  isShowQuestion(item: CorrectAnswerOVO, index: number) {
    // [채점이 완료된 문제 가리기] 옵션이 꺼져있다면
    if(!this.settings.isHideGradeSuccess) {
      return true;
    }

    // 채점이 되어있다면 가림
    return !this.userAnswers[index].isGrading;
  }

  goOmrMain() {
    this.$router.push({name: 'OmrMain'})
  }

  // 타이머 토글
  toggleTimer() {
    if(this.isUseTimer == true) {
      this.stopTimer();
      return 
    }

    // 시간 설정이 안됐다면
    if(this.settings.isTimer == false) {
      this.$toast('시간 설정을 해주세요');
      this.mini = false;
      return;
    }

    this.$toast(`제한시간은 ${this.settings.timerMinute}분이예요`)
    this.isUseTimer = true;
    let count = 0;
    const cvtSecond = this.settings.timerMinute * 60;
    this.timer = setInterval(() => {
      this.restTime = cvtSecond - ++count;

      if(this.restTime < 0) {
        clearInterval(this.timer);
        this.restTime  = 0;
        this.isUseTimer = false;
      }

    }, 1000);
  }

  // 타이머 중지
  async stopTimer() {
    const res =  await this.$confirm('타이머를 중지할까요?', CommonUtils.baseConfirmOption);

    if(res) {
      clearInterval(this.timer);
      this.restTime  = 0;
      this.isUseTimer = false;
      return;
    }
  }

  @Watch('$store.state.explanationForm.opened')
  changeExplanationDialog() {
    // 정답안 조회
    axios.get(`omr/correct-answers/${this.emNo}`)
    .then(r => {
      this.correctAnswers = r.data;
    })
  }

  @Watch('settings', {deep: true})
  changeSettings(ev: SettingsOmrVO): void {
    // 자동채점과 채점완료문항가리기는 셋트로 움직임
    if(ev.isAutoGrade == false) {
      this.settings.isHideGradeSuccess = false;
    }
    CommonUtils.putLocalStorageObject(Constants.SETTINGS_OMR, ev);
  }

  @Watch('isReport')
  save(e) {
    if(e == false) {
      return;
    }
    this.$store.dispatch('changeOmrLearn', false);

    axios.post('omr/user-answer', {emNo: this.emNo, answers: this.userAnswers})
    .then(r=>{
      this.$toast('제출되었어요');
      this.$router.push({name: 'OmrMain'})
    })
  }

  created() {
    if(this.isMobileReally) {
      window["webViewBridge"].send("interstitial", { queryString: "" }, null);
    }

    // 현재 OMR Learn에 접속했는지 여부
    this.$store.dispatch('changeOmrLearn', true);

    // 정답안 조회
    axios.get(`omr/correct-answers/${this.emNo}`)
    .then(r => {
      this.correctAnswers = r.data;

      // 사용자 답안지 리스트 생성
      this.correctAnswers.forEach((v, i) => {
        this.userAnswers.push({} as UserAnswerSlvIVO);
      });
    })

    if(this.getWindowSize() < 800) {
      this.$store.dispatch(`omr/closeModal`, {name: 'omr'});
    } else {
      this.$store.dispatch(`omr/openModal`, {name: 'omr'});
    }

    /*
    * 이거 개수조회로 변경해야함...
    */
    // 기출문제 시스템 업로드 이미지 개수 조회
    // 저작권때문에 막아야함..
    // 이거 나중에 다 바꿔야됨..(한쪽으로 몰아..)
    if(Constants.IS_USED_TEST_PAPER_LIBRARY) {
      axios.get(`omr/test-papers/library`, {params: {emNo: this.emNo}})
      .then(r => {
        this.testPaperCount += r.data.length
      })
    }

    /*
    * 이거 개수조회로 변경해야함...
    */
    // 개인이 업로드한 기출문제 시험지 조회
    // 이거 나중에 다 바꿔야됨..(한쪽으로 몰아..)
    axios.get(`omr/test-papers`, {params: {emNo: this.emNo}})
    .then(r => {
      this.testPaperCount += r.data.length
    })


    this.onResize();

    this.userAnswerMstIVO.emNo = this.emNo;

    // 환경설정 조회
    this.settings = CommonUtils.getLocalStorageObject(Constants.SETTINGS_OMR);

    // 스낵바 도움말 다시보지 않기 설정값 조회
    this.snackbarHide = CommonUtils.getLocalStorageObject(Constants.SNACKBAR_HIDE);

  }
}
